export default "__VITE_ASSET__CczxLRqz__"